import { useEffect } from 'react';
import * as Linking from 'expo-linking';
import { closeWindow } from 'src/_shared/utils/close-window/closeWindow';
import { dispatchCustomEvent } from 'src/_shared/utils/dispatch-custom-event/dispatchCustomEvent';
import { saveAccessToken } from 'src/helpers/google.helper';
import { getValuesFromHash, getValuesFromState } from 'src/helpers/url.helper';
import { allowExit, preventExit } from 'src/_shared/utils/prevent-exit/preventExit';

export const useEditorApp = () => {
  const url: string | null = Linking.useURL();

  // enables exit warning alert
  useEffect(() => {
    preventExit();
  }, []);

  useEffect(() => {
    if (url) {
      const hashValues = getValuesFromHash(window.location.hash.substring(1));
      const stateValue = hashValues['state' as keyof typeof hashValues] as string;
      const stateObj = stateValue ? getValuesFromState(stateValue) : undefined;

      // handle redirect after google login
      if (stateObj) {
        const expireDate = new Date();
        expireDate.setTime(Date.now() + parseInt(hashValues.expires_in) * 1000);
        saveAccessToken(hashValues.access_token, expireDate.getTime().toString());
        dispatchCustomEvent(new Event('google'));
        allowExit();
        closeWindow();
        preventExit();
      }
    }
  }, [url]);
};
